import type { PaidOverageReviewPort } from "../hooks/usePaidOverageReview"

/** Keep the review passive while presentation is disabled or explicit identity is unavailable. */
export const paidOverageReviewAvailability: PaidOverageReviewPort = {
  load: () => Promise.resolve(null),
  decide: () =>
    Promise.reject(new Error("Paid-overage acceptance has not launched")),
  recheck: () => Promise.resolve(null),
  classify: () => "rejected",
}
